import "shared/extensions/string";

import { EventNames } from "core/monitoring/types/enums";
import { LocaleIdToWisdomAiLocaleMap } from "shared/core/locale";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import Button from "shared/UI/Buttons/Button";
import { ReactComponent as WisdomAILogo } from "shared/assets/Icons/wisdom-ai-full.svg";
import { externalLink } from "core/links";
import { t } from "i18next";
import { trackEvents } from "core/monitoring/Events";
import useLocale from "core/hooks/useLocale/useLocale";

export const WisdomAIButtonCard = () => {
  const { localeId } = useLocale();
  const handleClickWisdomAI = () => {
    trackEvents(EventNames.WISDOM_AI_CLICK);
    externalLink(`${process.env.REACT_APP_WISDOM_AI_URI!}${LocaleIdToWisdomAiLocaleMap[localeId]}`);
  };

  return (
    <RoundedCard>
      <div className="mb-6">
        <div className="flex flex-col gap-1">
          <WisdomAILogo width="170" height="40" />
          <h3>{t("support.wisdomAI.subtitle")}</h3>
        </div>

        <p>{t("support.wisdomAI.description")}</p>
      </div>
      <Button text={t("support.wisdomAI.button")} onClick={handleClickWisdomAI} />
    </RoundedCard>
  );
};
